import { SharedDocumalisModule } from '@documalis/shared-documalis.module';
import { NgModule } from '@angular/core';
import { UserBskRoutes } from './userbsk.routes';
import { ListUserBskComponent } from './list-userbsk/list-userbsk.component';
import { FormUserBskComponent } from './_components/form-userbsk/form-userbsk.component';
import { AddUserBskComponent } from './add-userbsk/add-userbsk.component';
import { EditUserBskComponent } from './edit-userbsk/edit-userbsk.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [
        UserBskRoutes,
        SharedDocumalisModule,
        TranslateModule,
        FormUserBskComponent,
    ],
    declarations: [
        ListUserBskComponent,
        AddUserBskComponent,
        EditUserBskComponent
    ]
})
export class UserBskModule { }
